import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as comps from "./components";
import { ParentWidgetComponent } from './interfaces/parent-widget/parent-widget.component'
import { GroupPortalRoutingModule } from "./groupportal-routing.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { MaterialModule } from "../shared/material.module";
import { TruncatePipe } from "../shared/pipes/dashboard-invoices.pipe";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { GroupPortalDomService, GroupPortalDataService } from "./services";
import { AcepHttpInterceptor } from "../core/interceptors/acep-http.interceptor";
import { PaymentModule } from "@acepteam/payment";
import { ApplyPaymentComponent } from './components/apply-payment/apply-payment.component';
import { ResidencyDetailsComponent } from "./components/residency/residency-details.component";
//import { PaymentModule } from "@acepteam/payment";

@NgModule({
  declarations: [
    comps.MemberappBaseComponent,
    comps.Component1Component,
    comps.Component2Component,
    comps.DashboardComponent,
    comps.HomeComponent,
    comps.GroupInfoDashboardComponent,
    comps.ProviderStatusDashboardComponent,
    comps.PaymentMethodsDashboardComponent,
    comps.InvoicesDashboardComponent,
    comps.MembersComponent,
    comps.MyGroupComponent,
    comps.HistoryComponent,
    comps.CheckoutComponent,
    ParentWidgetComponent,
    comps.CommonBaseComponent,
    comps.AddressComponent,
    comps.AccountLookupComponent,
    comps.AccountLookupMatComponent,
    comps.EducationChildComponent,
    comps.ResidencyDetailsComponent,
    comps.GradDateComponent,
    TruncatePipe,
    ApplyPaymentComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    //CoreModule,
    SharedModule,
    PaymentModule,
    MaterialModule,
    GroupPortalRoutingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AcepHttpInterceptor, multi: true }
  ],
  exports: [comps.ResidencyDetailsComponent]
})
export class GroupPortalModule { }
